<template>
    <div>
        <!-- EDITABLE VIEW -->
        <v-select
            ref="select"
            v-if="!disableEdit"
            v-model="valueModel"
            solo
            :background-color="color"
            :items="items"
            chips
            label="Selected options"
            placeholder="Select options"
            hint="Selected options"
            :hide-details="true"
            multiple
            item-text="name"
            item-value="unique_id"
            auto-focus
            open-on-clear
            :menu-props="menuProps"
            @change="valuesChanged"
            @keydown.shift="shiftPressed=true"
            @keyup="shiftPressed=false"
        >
            <template
                slot="selection"
                slot-scope="{ item, index }"
            >
                <v-tooltip top color="primary">
                    <template v-slot:activator="{ on }">
                        <v-chip v-on="on"
                                label
                                color="grey darken-3"
                                v-if="index < 4">
                            <span>{{ formatChipName(item.name) }}</span>
                        </v-chip>
                    </template>
                    <span>{{ item.name }}</span>
                </v-tooltip>
                <span
                    v-if="index === 4"
                    class="white--text caption"
                >(+{{ valueModel.length - 4 }} others)</span>
            </template>

        </v-select>

        <!-- NON EDITABLE VIEW -->
        <v-chip v-if="disableEdit"
                class="ml-1 mt-1"
                text-color="white"
                dark
                small
                label
                color="grey darken-1"
                v-for="option in selectedOptions"
                :key="option.id">
            {{ ucFirst(option.name) }}
        </v-chip>

    </div>

</template>

<script>

import DataVariableChip from "../../../../components/UI/DataVariableChip";
import {shiftSelectMixin} from "../../../../components/mixins/shiftSelectMixin";

export default {

    mixins: [shiftSelectMixin],

    components: {
        DataVariableChip
    },

    props: {
        value: {
            type: Array,
            required: false,
            default: () => [],
        },
        items: {
            type: Array,
            required: true
        },
        disableEdit: {
            type: Boolean,
            required: false,
            default: false
        },
        color: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            valueModel: [],
            menuProps: {
                maxHeight: '800',
                overflowX: true
            },
        }
    },

    watch: {
        value(value) {
            this.valueModel = value;
        }
    },

    computed: {
        selectedOptions() {

            if (!this.valueModel) return [];

            return this.items.filter((option) => {

                let found2 = this.valueModel.find((id) => {

                    return option.unique_id === id;
                });

                if (found2) return true;
            });
        },
    },

    mounted() {

        this.valueModel = this.value ? [...this.value] : null;
    },

    methods: {

        valuesChanged(values) {

            if (values.length === 0) {
                Bus.$emit('flash-message', {
                    type: "warning",
                    message: "Select at least one option or delete this condition!"
                });
            }

            this.shiftSelectValues(values);
            this.$emit('input', values);
        },

        formatChipName(name) {
            let splits = name.split(' ');

            let chars = 0;
            let words = [];

            splits.forEach((split) => {
                chars += split.length;

                if (chars < 15) {
                    words.push(split);
                }
            });

            let chipName = words.join(' ');

            if (chipName.length === name.length) {
                return chipName;
            }

            return chipName + '..';
        },
    }
}
</script>
